import { UPLOAD_MODE } from "constants/booksHandoff";
import { SectionField } from "types/Models/Filing";
import { getLinkKey } from "./getLinkKey";
import { getModeKey } from "./getModeKey";

export const getUploadOrLinkInitialValues = (
  field: Pick<SectionField, "field_key" | "documents" | "link" | "mode">
): Record<string, unknown> => ({
  [field.field_key]: field.documents ?? [],
  [getLinkKey(field.field_key)]: field.link ?? "",
  [getModeKey(field.field_key)]: field.mode ?? UPLOAD_MODE,
});
